import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Row, Col, notification } from 'antd';
import {
	Logo,
	Title,
	XForm,
	XLottie,
	XThemeLottieCard,
} from '../Login/LoginStyle';
import {
	CenterWrapper,
	XPara1,
} from '../ForgotEmailPassword/ForgotEmailPasswordStyle';
import { Button, Input } from 'antd';
import { useNavigate } from 'react-router-dom';
import LoginAnimation from '../../json/Reclaim.json';
import Navbar from 'react-bootstrap/Navbar';
import {
	XContainer,
	XThemeContainer,
	XThemeGradientButton,
} from '../../styles/GlobalThemeStyle';
// Actions
import {
	resetPasswordApi,
	resetPasswordReset,
} from '../../actions/resetPasswordAction';
import { handleInputChange } from '../../utils/formFunctions';
import {
	changePasswordApi,
	changePasswordReset,
} from '../../actions/changePasswordAction';
import {
	XTheme2Button,
	XTheme2MainTitle,
} from '../../styles/GlobalThemeStyleCQ';

const ResetPassword = (props) => {
	const {
		resetPassword,
		resetPasswordReset,
		resetPasswordState,
		changePassword,
		changePasswordReset,
		changePasswordState,
	} = props;

	const [form] = XForm.useForm();
	const [formData, setFormData] = useState({
		email: localStorage.getItem('email'),
	});
	const navigate = useNavigate();

	useEffect(() => {
		if (resetPasswordState.apiState === 'success') {
			notification.success({ message: resetPasswordState.message });
			resetPasswordReset();
			navigate('/login');
		} else if (resetPasswordState.apiState === 'error') {
			notification.error({ message: resetPasswordState.message });
			resetPasswordReset();
			navigate('/forgot-email-password');
		}
	}, [resetPasswordState]);

	useEffect(() => {
		if (changePasswordState.apiState === 'success') {
			notification.success({ message: changePasswordState.message });
			changePasswordReset();
			navigate('/');
		} else if (changePasswordState.apiState === 'error') {
			notification.error({ message: changePasswordState.message });
			changePasswordReset();
		}
	}, [changePasswordState]);
	useEffect(() => {
		document.body.classList.add('bodyOverflowHideImageBg');
		return () => {
			document.body.classList.remove('bodyOverflowHideImageBg');
		};
	}, []);
	return (
		<XThemeContainer fluid>
			<Row
				className="align-items-center mt-5 mb-5 mb-md-0"
				gutter={[15, 15]}
			>
				<Col xs={24} className="d-flex justify-content-start">
					<span className="logo">
						<img
							style={{ width: 100 }}
							src={'/images/reclaim-revolution-logo.svg'}
							alt="logo"
						/>
					</span>
				</Col>
			</Row>
			<CenterWrapper className="align-items-center h-auto">
				<Row className="align-items-center w-100">
					<Col
						xs={{ span: 24, offset: 0 }}
						sm={{ span: 24, offset: 0 }}
						md={{ span: 12, offset: 6 }}
						lg={{ span: 6, offset: 9 }}
					>
						<div className="w-50 m-auto text-center">
							<XThemeLottieCard>
								<XLottie
									animationData={LoginAnimation}
									loop={true}
								/>
							</XThemeLottieCard>
						</div>
						<XTheme2MainTitle className="my-4 text-center">
							Reset Password
						</XTheme2MainTitle>
						{localStorage.getItem('changePassword') ? (
							<XPara1 className="mb-4 text-center">
								Please reset your password for security reasons
								to proceed further.
							</XPara1>
						) : (
							<XPara1 className="mb-4 text-center">
								Please reset your password for security reasons
								to proceed further.
							</XPara1>
						)}

						<XForm
							form={form}
							name="loginForm"
							layout="vertical"
							autoComplete="off"
							onFinish={() => {
								if (localStorage.getItem('changePassword')) {
									changePassword(formData);
								} else if (localStorage.getItem('otpVerified'))
									resetPassword(formData);
								else {
									notification.error({
										message: 'Email OTP not verified',
									});
									navigate('/forgot-email-password');
								}
							}}
						>
							<XForm.Item
								name="new_password"
								label="New Password"
								rules={[
									{
										required: true,
										message: 'Please input new password!',
									},
									{
										min: 8,
										message:
											'Password must be at least 8 characters long!',
									},
									{
										pattern:
											/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
										message:
											'Password must include at least one letter, one number, and one special character!',
									},
								]}
							>
								<Input.Password
									size="large"
									name="new_password"
									placeholder="Enter new password"
									onChange={(e) =>
										handleInputChange(
											e,
											formData,
											setFormData,
										)
									}
								/>
							</XForm.Item>

							<XForm.Item
								name="confirm_password"
								label="Confirm Password"
								dependencies={['new_password']}
								hasFeedback
								rules={[
									{
										required: true,
										message:
											'Please confirm your new password',
									},
									({ getFieldValue }) => ({
										validator(_, value) {
											if (
												!value ||
												getFieldValue(
													'new_password',
												) === value
											) {
												return Promise.resolve();
											}
											return Promise.reject(
												new Error(
													'The two passwords that you entered do not match!',
												),
											);
										},
									}),
								]}
							>
								<Input.Password
									size="large"
									name="confirm_password"
									placeholder="Confirm your password"
									onChange={(e) =>
										handleInputChange(
											e,
											formData,
											setFormData,
										)
									}
								/>
							</XForm.Item>

							<XForm.Item className="mt-4">
								<XTheme2Button
									className="w-100 py-4"
									htmlType="submit"
								>
									Reset Password
								</XTheme2Button>
							</XForm.Item>
						</XForm>
					</Col>
				</Row>
			</CenterWrapper>
		</XThemeContainer>
	);
};

const mapStateToProps = (state) => ({
	resetPasswordState: state.resetPassword,
	changePasswordState: state.changePassword,
});

const mapDispatchToProps = (dispatch) => ({
	resetPassword: (params) => dispatch(resetPasswordApi(params)),
	resetPasswordReset: () => dispatch(resetPasswordReset()),
	changePassword: (params) => dispatch(changePasswordApi(params)),
	changePasswordReset: () => dispatch(changePasswordReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
